"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOTIFICA_SUCCESSO = 'success';
exports.NOTIFICA_ERRORE = 'error';
exports.NOTIFICA_INFO = 'info';
exports.NUMERO_ABBONAMENTI = 'numero_abbonamenti';
exports.NUMERO_TESSERE_DEL_TIFOSO = 'numero_tessere_del_tifoso';
